import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const captionWrapperDefaultVariants = {
  "color": "neutral"
}
const captionWrapperCompoundVariants = []

const captionWrapperSlotNames = [
  [
    "root",
    "caption-wrapper__root"
  ],
  [
    "content",
    "caption-wrapper__content"
  ],
  [
    "btn",
    "caption-wrapper__btn"
  ],
  [
    "icon",
    "caption-wrapper__icon"
  ]
]
const captionWrapperSlotFns = /* @__PURE__ */ captionWrapperSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, captionWrapperDefaultVariants, getSlotCompoundVariant(captionWrapperCompoundVariants, slotName))])

const captionWrapperFn = memo((props = {}) => {
  return Object.fromEntries(captionWrapperSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const captionWrapperVariantKeys = [
  "color"
]
const getVariantProps = (variants) => ({ ...captionWrapperDefaultVariants, ...compact(variants) })

export const captionWrapper = /* @__PURE__ */ Object.assign(captionWrapperFn, {
  __recipe__: false,
  __name__: 'captionWrapper',
  raw: (props) => props,
  variantKeys: captionWrapperVariantKeys,
  variantMap: {
  "color": [
    "neutral",
    "inverted"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, captionWrapperVariantKeys)
  },
  getVariantProps
})